var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.588 8.004.295 1.706a1 1 0 0 1 0-1.41 1 1 0 0 1 1.41 0l6.3 6.292L14.301.295a1 1 0 0 1 1.411 0 1 1 0 0 1 0 1.41l-6.293 6.3 6.293 6.297a1 1 0 0 1-1.41 1.411L8.003 9.42l-6.298 6.293a1 1 0 0 1-1.41 0 1 1 0 0 1 0-1.41l6.292-6.299Z"
  })));
};
export default SvgClose;